var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUsUnavailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#A9A9A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5909 29.5734H20.4319C16.3272 29.5734 13 26.2462 13 22.1419C13 18.0376 16.3272 14.71 20.4319 14.71H27.5685C31.6728 14.71 35 18.0376 35 22.1419C35 26.2462 31.6728 29.5734 27.5685 29.5734L23.1423 34",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsUnavailable);
export default __webpack_public_path__ + "static/media/contact-us-unavailable.58ad46835e83c56f52105ff857790862.svg";
export { ForwardRef as ReactComponent };